/*
    记住当前分页信息，以便从详情页或其他页面返回列表页时，能还原上次页码
 */
const backtolist = {
state: {
    currentPage: 1
},

mutations: {
    SET_CURRENT_PAGE: (state, currentPage) => {
    state.currentPage = currentPage;
    }
},

actions: {
    setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
    }
}
};
export default backtolist;      


// WEBPACK FOOTER //
// ./src/store/modules/backtolist.js